export const getProductButtonMessages = (messageContext, productId) => {
    const result = [];
    let searchIndex = 1;
    let hasMessage = true;

    do {
        const buttonTextMessageKey = `${productId}.button.${searchIndex}.text`;
        const buttonUrlMessageKey = `${productId}.button.${searchIndex}.url`;
        const buttonIdMessageKey = `${productId}.button.${searchIndex}.id`;
        const hasUrlMessage = messageContext.hasMessage(buttonUrlMessageKey);
        hasMessage =
            messageContext.hasMessage(buttonTextMessageKey) &&
            messageContext.hasMessage(buttonIdMessageKey);
        const buttonTextHasValidRule =
            !messageContext.messageHasRule(buttonTextMessageKey) ||
            messageContext.messageRuleIsValid(buttonTextMessageKey);
        const buttonUrlHasValidRule =
            !hasUrlMessage ||
            !messageContext.messageHasRule(buttonUrlMessageKey) ||
            messageContext.messageRuleIsValid(buttonUrlMessageKey);
        const buttonIdHasValidRule =
            !messageContext.messageHasRule(buttonIdMessageKey) ||
            messageContext.messageRuleIsValid(buttonIdMessageKey);

        if (hasMessage) {
            if (
                buttonTextHasValidRule &&
                buttonUrlHasValidRule &&
                buttonIdHasValidRule
            ) {
                result.push({
                    text: messageContext.formatIntlMessage({
                        id: buttonTextMessageKey,
                    }),
                    url: hasUrlMessage
                        ? messageContext.formatIntlMessage({
                              id: buttonUrlMessageKey,
                          })
                        : "",
                    id: messageContext.formatIntlMessage({
                        id: buttonIdMessageKey,
                    }),
                });
            }
        }

        searchIndex++;
    } while (hasMessage);

    return result;
};

export const cartHasProducts = (cart) => {
    return cart.size !== 0;
};

export const cartIsEmpty = (cart) => {
    return cart.size === 0;
};

export const questionWasAnswered = (questionAppkey, answers) => {
    const ans = answers.getAnswer(questionAppkey);
    return !!ans && (ans.value !== undefined ? ans.value !== '' : ans !== '');
};

export const questionAnswerMatches = (questionAppkey, value, answers) => {
    const answerObj = answers.getAnswer(questionAppkey);
    if (!answerObj) return false;
    
    // Neuro answers sometimes store values in .value property, sometimes directly
    const answerValue = answerObj.value !== undefined ? answerObj.value : answerObj;

    const conditionValues = Array.isArray(value) ? value : [value];
    const userAnswers = Array.isArray(answerValue) ? answerValue : [answerValue];

    // OR logic: Return true if any user answer matches any condition value
    return userAnswers.some(ans => conditionValues.includes(ans)) 
           || userAnswers.some(ans => conditionValues.includes(String(ans)));
};

export const getSessionVariable = (key) => {
    try {
        const igniteSession = JSON.parse(sessionStorage.getItem('ignite') || '{}');
        const actionsMetadata = igniteSession?.actionsMetadata || {};
        
        if (!key.includes('.')) {
            return actionsMetadata[key];
        }

        return key.split('.').reduce((obj, p) => (obj && obj[p] !== undefined) ? obj[p] : undefined, actionsMetadata);
    } catch(e) {
        return undefined;
    }
};

export const sessionVariableMatches = (key, value, type) => {
    const sessionVal = getSessionVariable(key);
    
    switch (type) {
        case "sessionExists":
            return sessionVal !== undefined && sessionVal !== null && sessionVal !== '';
        case "sessionDoesNotExist":
            return sessionVal === undefined || sessionVal === null || sessionVal === '';
        case "sessionEquals":
            if (sessionVal === undefined || sessionVal === null) return false;
            const targetValuesEq = Array.isArray(value) ? value : [value];
            return targetValuesEq.includes(String(sessionVal));
        case "sessionNotEquals":
            if (sessionVal === undefined || sessionVal === null) return true;
            const targetValuesNeq = Array.isArray(value) ? value : [value];
            return !targetValuesNeq.includes(String(sessionVal));
        default:
            return false;
    }
};

export const conditionFulfilled = (condition, answers, cart) => {
    switch (condition.type) {
        case "hasCartProducts":
            return cartHasProducts(cart);
        case "noCartProducts":
            return cartIsEmpty(cart);
        case "hasCartSpecificProducts": {
            const requiredProducts = Array.isArray(condition.value) ? condition.value : [];
            return requiredProducts.length > 0 && requiredProducts.some(id => cart.has(String(id)));
        }
        case "noCartSpecificProducts": {
            const excludedProducts = Array.isArray(condition.value) ? condition.value : [];
            return excludedProducts.length === 0 || !excludedProducts.some(id => cart.has(String(id)));
        }
        case "answerEquals":
            return questionAnswerMatches(
                condition.key,
                condition.value,
                answers,
            );
        case "answerNotEquals":
            return !questionAnswerMatches(
                condition.key,
                condition.value,
                answers,
            );
        case "answerExists":
            return questionWasAnswered(condition.key, answers);
        case "answerDoesNotExist":
            return !questionWasAnswered(condition.key, answers);
        case "sessionEquals":
        case "sessionNotEquals":
        case "sessionExists":
        case "sessionDoesNotExist":
            return sessionVariableMatches(condition.key, condition.value, condition.type);
        default:
            return false;
    }
};
